import React from 'react';
import useFetchYears from '../hooks/useFetchYears';
import "../Styles/SelectYear.css";

const SelectYear = ({ selectedYear, handleChangeYear }) => {
  const { years, isLoading, error } = useFetchYears();

  const handleYearChange = (e) => {
    handleChangeYear(e.target.value);
  };

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error fetching years: {error.message}</p>;

  return (
    <div className="year-select-container">
      <label htmlFor="year-select" className="year-select-label">Vælg År: </label>
      <select id="year-select" value={selectedYear} onChange={handleYearChange} className="year-select">
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectYear;

